import React from 'react';
import styled from 'styled-components';

import PropertyAllRisksIcon from '../../assets/PropertyAllRisks.png';
import PublicLiabilityIcon from '../../assets/PublicLiability.png';
import MoneyIcon from '../../assets/Money.png';
import BusinessInterruptionIcon from '../../assets/BusinessInterruption.png';
import WorkInjuryCompensationIcon from '../../assets/WorkInjuryCompensation.png';
import FidelityGuaranteeIcon from '../../assets/FidelityGuarantee.png';

import {grid, gridCell} from '../../ui/common/grid';
import {mdDownN} from "../../ui/common";

const FeatureGroupStyle = styled.div`
    top: 820px;
    height: 472px;
    width: 1164px;
    position: absolute;
    margin: 0;
    left: 142px;
    ${mdDownN`
        height: auto;
        display: flex;
        flex-direction: column;
        position: relative;
        top: auto;
        left: auto;
        width: 100vw;
    `}
`;

const FeatureGroupTitleStyle = styled.div`
    top: 0px;
    height: auto;
    width: auto;
    position: absolute;
    margin: 0;
    left: 10px;
    font-family: "Stag-Medium", Helvetica, Arial, serif;
    font-size: 40.0px;
    color: rgba(10, 31, 68, 1.0);
    text-align: left;
    letter-spacing: 1.0px;
    line-height: 48.0px;
    ${mdDownN`
        position: relative;
        margin-top: 69px;
        margin-bottom: 38px;
        left:auto;
        top:auto;
        padding-left: 22px;
        font-size: 32.0px;
        line-height: 40.0px;
        letter-spacing: 1px;
        font-weight: 500;
    `}
`;

const FeatureCardGroupStyle = styled.div`
    top: 90px;
    height: auto;
    width: auto;
    position: absolute;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    text-align: left;
    ${grid({rows: 2, columnTemplate: ['1fr', '1fr', '1fr'], columnGap: '10px', rowGap: '10px'})}
    ${mdDownN`
        position:relative;
        top: auto;
        width: 100vw;
        grid-template-columns: 1fr;
        ${grid({rows: 6, columnTemplate: ['1fr'], columnGap: '0px', rowGap: '0px'})}
    `}
`;

const FeatureCardStyle = styled.div`
    height: 184px;
    width: 384px;
    position: relative;
    margin: 0;
    left: 0px;
    
    :hover {
        box-shadow: 0 8px 22px 0 rgba(169,169,169,0.32);
    } 

    ${props => gridCell({row: props.row, column: props.column})}
    ${mdDownN`
        height: auto;
        width: 100%;
        ${props =>{
            let temp = [[1,1],[1,2],[1,3],[2,1],[2,2],[2,3]]
            let index = temp.indexOf(temp.find(x=>x[0]===props.row&&x[1]===props.column))
            return  gridCell({row: index+1, column: 1})
        }}
        padding-left: 22px;
        margin-bottom: 49px;
        :hover {
            box-shadow: none;
        } 
    `}
`;

const FeatureIconImgStyle = styled.img`
    top: 33px;
    height: 23px;
    width: 27px;
    position: absolute;
    margin: 0;
    left: 10px;
    ${mdDownN`
        width: ${props=>props.w}px;
        height: ${props=>props.h}px;
        left: auto;
        top: auto;
        position: relative;
        display:block;
        margin-bottom: 24px;
    `}
`;

const FeatureTitleStyle = styled.div`
    top: 78px;
    height: 28px;
    width: 80%;
    position: absolute;
    margin: 0;
    left: 10px;
    font-family: "Stag-Medium", Helvetica, Arial, serif;
    font-size: 20.0px;
    color: rgba(0, 0, 0, 1.0);
    text-align: left;
    letter-spacing: 1.0px;
    line-height: 28.0px;
    ${mdDownN`
        top: auto;
        left: auto;
        height: auto;
        position: relative;
        display:block;
        margin-bottom: 8px;
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 28px;
    `}
`;

const FeatureContentStyle = styled.div`
    top: 114px;
    height: auto;
    width: 80%;
    position: absolute;
    margin: 0;
    left: 10px;
    font-family: "Inter-Regular", Helvetica, Arial, serif;
    font-size: 16.0px;
    color: rgba(0, 0, 0, 1.0);
    text-align: left;
    line-height: 24.0px;
    ${mdDownN`
        top: auto;
        left: auto;
        position: relative;
        display:block;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
    `}
`;


export default function LandingFeatures() {
    return (
        <FeatureGroupStyle>
            <FeatureGroupTitleStyle>
                Product Features
            </FeatureGroupTitleStyle>
            <FeatureCardGroupStyle>

                <FeatureCardStyle row={1} column={1}>
                    <FeatureIconImgStyle w={31} h={28} src={PropertyAllRisksIcon}/>
                    <FeatureTitleStyle>
                        Property All Risks
                    </FeatureTitleStyle>
                    <FeatureContentStyle>
                        Incidents of loss/damage to building, stocks and machinery and plants.
                    </FeatureContentStyle>
                </FeatureCardStyle>

                <FeatureCardStyle row={1} column={2}>
                    <FeatureIconImgStyle w={29} h={38} src={PublicLiabilityIcon}/>
                    <FeatureTitleStyle>
                        Public Liability
                    </FeatureTitleStyle>
                    <FeatureContentStyle>
                        Cover for legal liability to 3rd party due to bodily injury or property damage, in connection with business.
                    </FeatureContentStyle>
                </FeatureCardStyle>

                <FeatureCardStyle row={1} column={3}>
                    <FeatureIconImgStyle w={28.35} h={37.12} src={MoneyIcon}/>
                    <FeatureTitleStyle>
                        Monetary Loss
                    </FeatureTitleStyle>
                    <FeatureContentStyle>
                        Loss of money while it’s on site or in transit.
                    </FeatureContentStyle>
                </FeatureCardStyle>

                <FeatureCardStyle row={2} column={1}>
                    <FeatureIconImgStyle w={35.24} h={31.09} src={BusinessInterruptionIcon}/>
                    <FeatureTitleStyle>
                        Business Interruption
                    </FeatureTitleStyle>
                    <FeatureContentStyle>
                        The event of loss resulting from an interruption to the business.
                    </FeatureContentStyle>
                </FeatureCardStyle>

                <FeatureCardStyle row={2} column={2}>
                    <FeatureIconImgStyle w={38} h={32} src={WorkInjuryCompensationIcon}/>
                    <FeatureTitleStyle>
                        Work Injury Compensation
                    </FeatureTitleStyle>
                    <FeatureContentStyle>
                        Legal obligations to protect for staff work injury.
                    </FeatureContentStyle>
                </FeatureCardStyle>

                <FeatureCardStyle row={2} column={3}>
                    <FeatureIconImgStyle w={38} h={35} src={FidelityGuaranteeIcon}/>
                    <FeatureTitleStyle>
                        Fidelity Guarantee
                    </FeatureTitleStyle>
                    <FeatureContentStyle>
                        Loss of money/goods by fraudulent/dishonest act of staff.
                    </FeatureContentStyle>
                </FeatureCardStyle>

            </FeatureCardGroupStyle>
        </FeatureGroupStyle>
    );
}
